import LoadingButton from '@zenbusiness/zui/LoadingButton';
import PropTypes from 'prop-types';

import { ActionButtonsGrid , FocusGrid, ContainerGrid } from '#client/components/Grid';

import Content from './Content';
import IllustrationImage from './IllustrationImage';
import { DialogContentStyled } from './LinkAccountOptions.styles';

function LinkAccountOptions({ handleClose }) {
  return (
    <>
      <DialogContentStyled role="form">
        <ContainerGrid>
          <FocusGrid>
            <IllustrationImage />
            <Content handleClose={handleClose} />
          </FocusGrid>
        </ContainerGrid>
      </DialogContentStyled>
      <ActionButtonsGrid type="secondary">
        <LoadingButton
          color="primary"
          fullWidth
          onClick={handleClose}
          size="large"
          variant="contained"
        >
          Close
        </LoadingButton>
      </ActionButtonsGrid>
    </>
  );
}

LinkAccountOptions.propTypes = {
  handleClose: PropTypes.func.isRequired
};

export default LinkAccountOptions;
